import { COLORS } from "./constants";
import type { ServerBasePrice } from "services/types";
import type { CandleWithFlag } from "./types";

export function drawLine(
  ctx: CanvasRenderingContext2D,
  dataArr: (ServerBasePrice | CandleWithFlag)[],
  startIndex: number,
  visibleCount: number,
  left: number,
  candleWidth: number,
  priceToY: (price: number) => number,
  animatedLinePrice: number | null,
) {
  ctx.beginPath();
  ctx.strokeStyle = COLORS.up;
  ctx.lineWidth = 2;

  for (let i = 0; i < visibleCount; i++) {
    const dataIndex = startIndex + i;
    if (dataIndex >= dataArr.length) continue;

    const item = dataArr[dataIndex];
    if (!item || !("price" in item)) continue;

    const x = left + (i + 0.5) * candleWidth;
    const price =
      animatedLinePrice !== null && dataIndex === dataArr.length - 1
        ? animatedLinePrice
        : item.price;

    const y = priceToY(price);
    if (i === 0) ctx.moveTo(x, y);
    else ctx.lineTo(x, y);
  }

  ctx.stroke();
}
